import { useEffect, useState } from 'react';

declare global {
  interface GlobalThis {
    Cookiebot?: {
      consent: {
        statistics: boolean;
      };
    };
  }
}

export const useCookieConsent = () => {
  const [cookieBotConsentStatistics, setCookieBotConsentStatistics] = useState<boolean>(false);

  useEffect(() => {
    if (globalThis.Cookiebot?.consent?.statistics) {
      setCookieBotConsentStatistics(true);
    }

    const handleAccept = () => {
      setCookieBotConsentStatistics(Boolean(globalThis.Cookiebot?.consent?.statistics));
    };

    const handleDecline = () => {
      setCookieBotConsentStatistics(false);
    };

    globalThis.addEventListener('CookiebotOnAccept', handleAccept);
    globalThis.addEventListener('CookiebotOnDecline', handleDecline);

    return () => {
      globalThis.removeEventListener('CookiebotOnAccept', handleAccept);
      globalThis.removeEventListener('CookiebotOnDecline', handleDecline);
    };
  }, []);

  return { cookieBotConsentStatistics };
};
